import React from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { updateLocationSearch } from 'utils/url';
import { formatCurrencyValue } from 'utils/currency';
import { btnLocationEnum } from 'utils/segment';
import UpdateCartButton from '../UpdateCartButton/UpdateCartButton';
import styles from './GwpProduct.module.css';

const GwpProduct = (props) => {
  const {
    subtotal,
    viewSize,
    version,
    shareUrl,
    name,
    imageUrl,
    variants,
    gwpThreshold,
    gwp,
    gwpProducts,
  } = props;
  const variant = variants[0];
  const parsedGwpThreshold = formatCurrencyValue(gwpThreshold);
  return (
    <li className={`${styles.productContainer} ${styles[viewSize]}`}>
      <Link
        to={updateLocationSearch(
          {
            product_link: shareUrl,
          },
          { accordionInGrid: true }
        )}
      >
        <span className="sr-only">Click to read product details</span>
        <div className={styles.imageContainer}>
          <LazyLoad once>
            <img className={styles.image} alt={`${name}`} src={imageUrl} />
          </LazyLoad>
        </div>
        <span className={styles.name}>
          {name}{' '}
          <p className={styles.price}>
            {' '}
            with ${`${parsedGwpThreshold}`}+ Purchase
          </p>
        </span>
      </Link>
      <div className={styles.buttonContainer}>
        <UpdateCartButton
          productName={name}
          isGwp={gwp}
          sponsored
          sponsoredThreshold={gwpThreshold}
          subtotal={subtotal}
          nonColorVariant={false}
          shareUrl={shareUrl}
          version={version}
          viewSize={viewSize}
          isAccordion={false}
          variant={variant}
          gwpProducts={gwpProducts}
          buttonLocation={btnLocationEnum.productCard}
        />
      </div>
    </li>
  );
};

export default GwpProduct;
